<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="fleetSafetyForm">
        <div class="my-section-box__headline">{{ 'common.value_calculator_fleet_safety_title' | cxTranslate }}</div>
        <div class="my-section-box fleetInfo" id="fleetInfo">
          <div class="my-section-box-inner">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="annualFleetAccidentRate">
                  {{ 'common.airDiscBrake_value_calculator_annualFleetAccidentRate' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="number" formControlName="annualFleetAccidentRate" (keyup)="calculateAndSetSum()" />
                    @if (form.annualFleetAccidentRate.invalid && (form.annualFleetAccidentRate.dirty || form.annualFleetAccidentRate.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                    <!-- {{ 'common.value_calculator_tractors_text' | cxTranslate }} -->
                    %
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_popup_annualfeet_title',
                                   'common.airDiscBrake_value_calculator_popup_annualfeet')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-Safety Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="noOfRearEndCollisionsDuringLifecycle">
                  {{ 'common.airDiscBrake_value_calculator_noofRearEndCollisionsDuringLifeCycle' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="noOfRearEndCollisionsDuringLifecycle" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    Incidents
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                            'common.airDiscBrake_value_calculator_noofRearEndCollisionsDuringLifeCycle',
                             'common.airDiscBrake_value_calculator_popup_rearendCycle')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-Safety Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="rearEndCollisionUnitCost">
                {{ 'common.airDiscBrake_value_calculator_rearEndCollisionUnitCost' | cxTranslate }} </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="rearEndCollisionUnitCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                            'common.airDiscBrake_value_calculator_rearEndCollisionUnitCost',
                             'common.airDiscBrake_value_calculator_popup_rearendCost')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc fleet-Safety Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="lifecycleRearEndCollisionsFleetCost">
                  {{ 'common.airDiscBrake_value_calculator_lifeCycleRearEndCollisionsFleetCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="lifecycleRearEndCollisionsFleetCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow"
                alt="Air Disc fleet-Safety Service Back">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow"
                alt="Air Disc fleet-Safety Service Next"></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>